// Helper function to handle image imports from require()
export const getImageUrl = (imageModule) => {
  if (typeof imageModule === 'string') {
    return imageModule;
  }
  if (imageModule && typeof imageModule === 'object') {
    return imageModule.default || imageModule;
  }
  return '';
};

// Helper function to safely require images
export const requireImage = (path) => {
  try {
    const imageModule = require(path);
    return getImageUrl(imageModule);
  } catch (error) {
    console.warn(`Failed to load image: ${path}`, error);
    return '';
  }
};
